import ReactModal from 'react-modal';

import CUSTOM_STYLES from '../../utils/modalStyle';
import { PrimaryButton } from '../Buttons/Buttons';

import styles from './OrderAlertModal.module.scss';

function OrderAlertModal({
  alertText,
  isModalOpen,
  modalLabel,
  continueBtnText = 'Συνέχεια',
  callback,
}) {
  const customStyles = {
    overlay: {
      ...CUSTOM_STYLES.overlay,
    },
    content: {
      ...CUSTOM_STYLES.content,
      width: '30.5rem',
      maxWidth: '100%',
    },
  };
  return (
    <ReactModal isOpen={isModalOpen} style={customStyles} contentLabel={modalLabel} ariaHideApp={false}>
      <div className={styles.modalContainer} data-cy="error-modal">
        <p className={styles.text}>{alertText}</p>
        <div>
          <PrimaryButton onClick={callback} data-cy="alert-ok">
           {continueBtnText}
          </PrimaryButton>
        </div>
      </div>
    </ReactModal>
  );
}

export default OrderAlertModal;
